module.exports = __webpack_public_path__ + "media/images/icon-svg/video-38cd02cef1ad3709fd951728b14faced.svg";